export const fontSizes = {
  small: 14,
  small2: 10,
  small3: 15,
  small4: 13,
  default: 16,
  medium: 24,
  large: 30
}